import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import { commafy, decommafy, swal, toEnglishDigits, typeChecker } from "../../../utils/methods";
import { _post } from "../../../utils/network";

import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb.component';
import FormField from "../../../components/Form/FormField/FormField.component";
import LoadingButton from '../../../components/LoadingButton/LoadingButton.component';

const SETTING_KEY = 'WALLET_UNIT_VALUES';

const WalletUnitValuesEdit = () => {
	const { t } = useTranslation();
	const [saveButtonIsLoading, setSaveButtonIsLoading] = useState(false);
	const [pageIsLoading, setPageIsLoading] = useState(true);
	const [setting, setSetting] = useState({});
	const breadcrumbItems = [
		{ title: t('dashboard'), link: '/dashboard' },
		{ title: t('wallet_unit_values') }
	];
	const confirmSwal = statements => {
		swal(() => statements(), {
			text: t('are_you_sure_to_do_this'),
			confirmButtonText: t('yes'),
			cancelButtonText: t('no')
		});
	};

	const getSetting = async () => {
		setPageIsLoading(true);
		let response = await _post('/settings/admin/getOne', { setting_key: SETTING_KEY });
		setPageIsLoading(false);
		switch(response.code){
			case 200:
				setSetting(response.data.setting?.setting_content || {});
				break;
			default:
				toast.error(response[t('api_message')]);
		}
	};

	const parseRialValue = value => parseInt(toEnglishDigits(decommafy(value.trim())));

	const updateSetting = async (event) => {
		event.preventDefault();
		if(saveButtonIsLoading)
			return 0;
		let zarRialValue = parseRialValue(event.target.zarRialValue.value);
		if(!typeChecker(zarRialValue, 'number') || zarRialValue <= 0)
			return toast.warn(t('zar_rial_value') + ' ' + t('cant_be_empty'));
		let simRialValue = parseRialValue(event.target.simRialValue.value);
		if(!typeChecker(simRialValue, 'number') || simRialValue <= 0)
			return toast.warn(t('sim_rial_value') + ' ' + t('cant_be_empty'));
		if(zarRialValue % simRialValue !== 0)
			return toast.warn(t('zar_must_be_multiple_of_sim'));
		let body = {
			setting_key: SETTING_KEY,
			setting_content: {
				zar_rial_value: zarRialValue,
				sim_rial_value: simRialValue
			},
			setting_more: {}
		};
		confirmSwal(async () => {
			setSaveButtonIsLoading(true);
			let response = await _post('/settings/admin/edit', body);
			setSaveButtonIsLoading(false);
			switch(response.code){
				case 200:
					toast.success(response[t('api_message')]);
					setSetting(body.setting_content);
					break;
				default:
					toast.error(response[t('api_message')]);
			}
		});
	};

	useEffect(() => {
		getSetting();
	}, []);

	return (
		<>
			<Breadcrumb items={breadcrumbItems} />
			<div className="card mb-3">
				<div className="card-header">
					<h5 className="mb-0">{t('wallet_unit_values')}</h5>
				</div>
				<div className="card-body bg-light">
					{pageIsLoading ?
						<div className="text-center py-4">
							<div className="spinner-border text-primary" role="status">
								<span className="visually-hidden">Loading...</span>
							</div>
						</div>
					:
						<form onSubmit={updateSetting}>
							<div className="row gx-2">
								<FormField type="number" fieldKey="zarRialValue" title={t('zar_rial_value')} tip={t('rial')} value={commafy(setting?.zar_rial_value)} required ltr />
								<FormField type="number" fieldKey="simRialValue" title={t('sim_rial_value')} tip={t('rial')} value={commafy(setting?.sim_rial_value)} required ltr />
							</div>
							<div>
								<LoadingButton className="btn btn-primary d-inline-block mt-3 me-2" type="submit" name="save" isLoading={saveButtonIsLoading}>
									<i className="fa fa-save"></i> {t('update')}
								</LoadingButton>
							</div>
						</form>
					}
				</div>
			</div>
		</>
	);
};

export default WalletUnitValuesEdit;
